import React, { useState } from 'react';
import styled from 'styled-components';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { mobile } from "../../responsive";
import { rel8Pink, rel8Purple, rel8White } from "../../globals";
import { editGalleryName } from '../../utils/api-calls';

const BackDrop = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;

const SubCon = styled.div`
  background-color: ${rel8White};
  width: 350px;
  max-height: 80%;
  border-radius: 10px;
  padding: 20px;
  overflow-y: auto;

  ${mobile({
    width: "250px",
  })}
`;

const SubConHeader = styled.p`
  font-weight: 700;
  text-align: center;
`;

const Form = styled.form`
  margin: 20px 0px;
  display: flex;
  flex-direction: column;
`;

const FormLabel = styled.label`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  margin: 10px 0px;
`;

const FormDataComp = styled.input`
  padding: 5px 0px;
  background-color: transparent;
  border: none;
  border: 1px solid ${rel8Purple};
  border-radius: 5px;
  padding: 5px;
  color: ${rel8Purple};
  outline: none;
  &::placeholder {
    color: ${rel8Purple};
  }
`;

const SubConBtnHold = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px;
`;

const SubConBtn = styled.div`
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: ${(props) =>
    props.typex === "filled" ? `${rel8Purple}` : `${rel8Pink}`};
  color: ${(props) =>
    props.typex === "filled" ? `${rel8White}` : `${rel8Purple}`};
  cursor: pointer;
`;

const EditGalleryName = ({ isOpen, onClose, onSave, id, currentName }) => {
  const [editedName, setEditedName] = useState(currentName);
  const queryClient = useQueryClient();

  const { isLoading, mutate: updateGalleryNameMutation } = useMutation(
    (newName) => editGalleryName(id, newName),
    {
      onMutate: () => {
        toast.info("Event Update in progress", {
          progressClassName: "toastProgress",
          icon: false,
        });
      },
      onSuccess: (response) => {
        toast.success("Gallery name updated successfully", {
          progressClassName: "toastProgress",
          icon: false,
        });

        onSave(editedName);
        onClose();
        queryClient.invalidateQueries("all-galleries");
      },
      onError: (error) => {
        toast.error(`Error saving name: ${error.message}`);
      },
    }
  );

  const handleSave = async () => {
    if (editedName.trim() === '') return;

    updateGalleryNameMutation(editedName);
  };

  const handleClose = () => {
    setEditedName(currentName); // Reset to original name
    onClose();
  };

  if (!isOpen) return null;

  return (
    <BackDrop>
      <style>
        {`
          body {
            overflow: hidden;
          }
        `}
      </style>
      <SubCon>
        <SubConHeader>Edit Gallery Name</SubConHeader>
        <Form>
          <FormLabel>
            Gallery Name:
            <FormDataComp
              type="text"
              value={editedName}
              onChange={(e) => setEditedName(e.target.value)}
              placeholder="Enter gallery name"
              maxLength={50}
              // autoFocus
            />
          </FormLabel>
        </Form>
        <SubConBtnHold>
          <SubConBtn type="button" onClick={handleClose} disabled={isLoading}>
            Cancel
          </SubConBtn>
          <SubConBtn type="button" typex="filled" onClick={handleSave} disabled={isLoading}>
            {isLoading ? 'Saving...' : 'Save'}
          </SubConBtn>
        </SubConBtnHold>
      </SubCon>
    </BackDrop>
  );
};

export default EditGalleryName;